import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// utils
import { getCampaignData } from '../../utils/campaignDataEngine';

const data = getCampaignData();

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='recruitment-campaign-financial-planning-section-1'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>What a career as a Northwestern Mutual financial advisor <WidowBlock>looks like</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography disableBottomPadding>
            {data.financialPlanningSection1.subText}
          </Typography>
          <BulletedList
            bulletType='checkmark'
            bulletedListData={data.financialPlanningSection1.bulletTextArray}
          />
        </>
      )}
      // image props
      imageAltText='A culturally diverse group of business professionals working together.'
      imageSrcDefault={data.financialPlanningSection1.desktopImageWebp.toString()}
      imageSrcMobile={data.financialPlanningSection1.mobileImageWebp.toString()}
    />
  );
};

